
export default {
  props: {
    autocompleteComponent: {
      type: String,
      default: "",
    },
    noNewsLetter: {
      default: false,
    },
    noAddress: {
      default: false,
    },
    noUser: {
      default: false,
    },
    address_no: {
      default: false,
    },
  },
  data() {
    return {
      manual: false,
    };
  },
  mounted() {
    this.$nuxt.$on('openManual',_=>{
      this.manual = true;
    })
  },
  methods: {},
};
